export default "__VITE_ASSET__4c0a148a__"